/** @format */

import ComplexTenderEditPage from './ComplexTenderEditPage';
export default ComplexTenderEditPage;
